<template id="">

  <ul class="sidebar-menu">
      <li class="header">Opciones</li>



      <!--
      <li class="treeview">
          <a href="<?=base_url()?>admin/resenas/">
              <i class="fa fa-shopping-bag"></i> <span>Reseñas</span>
          </a>
      </li>
-->

      <li class="treeview active">
          <a href="#">
              <i class="fa fa-dashboard"></i> <span>Asistencia Colaborador</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
          </a>
          <ul class="treeview-menu">
              <li class="active">
                <router-link to="/marcaciones"><i class="fa fa-circle-o"></i> Marcaciones </router-link>
              </li>
              <li>
                 <router-link to="/autorizacion"><i class="fa fa-circle-o"></i> Autorización de Papeletas </router-link>
              </li>
              <li class="active">
                 <router-link to="/papeletas_salida"><i class="fa fa-circle-o"></i> Papeletas de Salida </router-link>
              </li>
          </ul>
      </li>

      <!--
      <li class="treeview">
        <a href="#">
            <i class="fa fa-dashboard"></i> <span>Mantenimiento (<small>Asistencia</small>)</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
        </a>
        <ul class="treeview-menu">
            <li class="active">
              <router-link to="/papeletas/aprobar"><i class="fa fa-windows"></i> Aprobador de Papeleta</router-link>
            </li>
        </ul>

      </li>

      -->

  </ul>


</template>
<script>
  export default {
    name : 'Navigation',
    data() {
      return {

      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/shared/Navigation.vue